import { computed, toValue, watch } from 'vue';
import { getPopularSportLiveTvEvents, getSportLiveTvCategories } from '@/api/sport-live-tv';
import { useAsyncData } from '@/composables/use-async-data';
import { SPORT_LIVE_TV_CATEGORIES_LIMIT, SPORT_LIVE_TV_DEFAULT_STATUS, SPORT_LIVE_TV_POPULAR_LIMIT } from '@/sport-live-tv/constants';

export const useSportLiveTvOverview = (status = SPORT_LIVE_TV_DEFAULT_STATUS) => {
  const categoriesRequest = useAsyncData(() => getSportLiveTvCategories(toValue(status), 0, SPORT_LIVE_TV_CATEGORIES_LIMIT));
  const popularRequest = useAsyncData(() => getPopularSportLiveTvEvents(0, SPORT_LIVE_TV_POPULAR_LIMIT));

  watch(() => toValue(status), categoriesRequest.execute);

  const categories = computed(() => categoriesRequest.data.value ?? []);
  const popular = computed(() => popularRequest.data.value ?? []);
  const isLoading = computed(() => categoriesRequest.isLoading.value || popularRequest.isLoading.value);
  const isError = computed(() => categoriesRequest.isError.value || popularRequest.isError.value);

  const refetch = () => {
    categoriesRequest.execute();
    popularRequest.execute();
  };

  return { categories, popular, isLoading, isError, refetch };
};
